module.exports = __webpack_public_path__ + "img/footer7.ebf862f9.svg";